import React, { Component } from 'react';
import styled from 'styled-components';

import { getSplitedDivs } from '../../../../common/helper/commonHelper.js'

/*
props:
 onClick: callback function
*/

class Training5 extends Component {
    constructor(props) {
        super(props);

        this.state = {
            subject: this.props.subject
        }
    }
    render() {
        return (
            <Body Width={this.props.width} Height={this.props.height}>
                <TextWrap>
                    <Text>
                        {getSplitedDivs(this.props.subject.textJp, '\n')}
                    </Text>
                </TextWrap>
            </Body>
        );
    }
}

export { Training5 };

const Body = styled.div`
    width: ${props => (props.Width)};
    height: ${props => (props.Height)};
    position: relative;
`;
const TextWrap = styled.div`
    width: calc(100% - 20px);
    height: calc(100% - 20px);
    text-align: center;
    padding: 20px 10px 0 10px;
    display: flex;
    justify-content: center;
    overflow-y: auto;
`;
const Text = styled.div`
    text-align: left;
    font-size: 16px;
`;

